import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Settings/Branches/forms";
import headers from "../../../../Data/Forms/Settings/Branches/headers";
import {
  create_branch,
  get_all_sub_branches,
  get_branch,
  update_branch,
} from "../../../../Controllers/Settings/Branches";
import toast from "react-hot-toast";
import { convert_to_file } from "../../../../Controllers/Global";
import Loadercomponent from "../../../../Componets/Loader";
import { Button, Select, Spin } from "antd";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Formcomponent from "../../../../Componets/Formcomponents/component";
import {
  create_bulk_product,
  get_all_unavailable_products,
} from "../../../../Controllers/Products/Products";
import { LoadingOutlined } from "@ant-design/icons";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";

const ImportForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const branch = id
        ? await update_branch({ ...data?.data, id: id })
        : await create_branch(data?.data);

      if (branch?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(branch?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (branch?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(branch?.message);
        }

      }
    }
  };

  const handleData = async (branch) => {
    let image = branch?.image ? branch?.image : "";
    let file = await convert_to_file(image);
    let name = branch?.name ? branch?.name : "";
    let email = branch?.email ? branch?.email : "";
    let phone = branch?.phone ? branch?.phone : "";
    let tax = branch?.tax ? branch?.tax : "";
    let area = branch?.area ? branch?.area : "";
    let city = branch?.city ? branch?.city : "";
    let state = branch?.state ? branch?.state : "";
    let country = branch?.country ? branch?.country : "";
    let status = branch?.status ? branch?.status : 0;

    values[0].options[0].form.value = file;
    values[0].options[1].form.value = name;
    values[0].options[2].form.value = email;
    values[0].options[3].form.value = phone;

    values[1].options[0].form.value = tax;

    values[2].options[0].form.value = area;
    values[2].options[1].form.value = city;
    values[2].options[2].form.value = state;
    values[2].options[3].form.value = country;

    values[3].options[0].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const branch = await get_branch(data);
      if (branch?.status) {
        handleData(branch?.data);
      } else {
        toast?.error(branch?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [options, setOptions] = useState();
  const [selectedBranch, setSelectedBranch] = useState();
  const [products, setProducts] = useState();
  const [tableLoader, setTableLoader] = useState(false);

  const handleSearch = async (e) => {
    const data = {
      search: "",
    };

    const subbranches = await get_all_sub_branches(data);

    if (subbranches?.status) {
      let branchoptions = [];

      subbranches?.data?.data?.map((v, i) => {
        branchoptions?.push({ value: v?._id, label: v?.name });
      });

      setOptions(branchoptions);
    } else {
      toast?.error(subbranches?.message);
    }
  };

  const handleSelect = async (e) => {
    setSelectedBranch(e);

    if (e) {
      setTableLoader(true);

      const data = {
        branch: e,
      };

      const unavailableProducts = await get_all_unavailable_products(data);

      if (unavailableProducts?.status) {
        let allproducts = [];

        unavailableProducts?.data?.map((v, i) => {
          let productunitsdetails = [];

          v?.product_units_details?.map((value, index) => {
            productunitsdetails?.push({
              name: value?.name_details?.name,
              conversion: value?.conversion,
              purchase_price: value?.purchase_price,
              sale_price: value?.sale_price,
              status: 1,
            });
          });

          allproducts?.push({
            name: v?.name,
            barcode: v?.barcode,
            unit: v?.unit?.name,
            category: v?.category?.name,
            brand: v?.brand?.name,
            stock: v?.stock,
            expiry: v?.expiry,
            purchase_price: v?.purchase_price,
            sale_price: v?.sale_price,
            tax: v?.tax,
            type: v?.type,
            status: v?.status,
            details: productunitsdetails,
          });
        });

        setProducts(allproducts);
        setTableLoader(false);
      } else {
        toast?.error(unavailableProducts?.message);
        setTableLoader(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (products?.length > 0) {
      setButtonLoader(true);

      const data = {
        details: products,
        branch: selectedBranch,
      };

      const bulkproduct = await create_bulk_product(data);

      if (bulkproduct?.status) {
        toast?.success(bulkproduct?.message);
        setButtonLoader(false);
        setSelectedBranch();
        setProducts();
      } else {
        toast?.error(bulkproduct?.message);
        setButtonLoader(false);
        setSelectedBranch();
        setProducts();
      }
    } else {
      toast?.error("No products found");
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <ScrollWrapper summary={2}>
        <Loadercomponent loader={loader}>
          <Formcomponent>
            <Bodycomponent classname="">
              <Select
                size="large"
                className="w-full text-regular"
                placeholder="Select Branch"
                onClick={handleSearch}
                value={selectedBranch}
                options={options}
                onChange={handleSelect}
              />
              <div className="py-8">
                <Loadercomponent loader={tableLoader}>
                  <table className="w-full">
                    <thead>
                      <tr className=" text-sm text-gray-500 text-medium">
                        <th className="border p-2 font-normal text-center">
                          SL.NO
                        </th>
                        <th className="border p-2 font-normal text-left">NAME</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products?.map((value, index) => {
                        return (
                          <tr className=" text-xs">
                            <td className="p-2 border text-center">
                              {index + 1}
                            </td>
                            <td className="p-2 border text-left">
                              {value?.name}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {selectedBranch ? (
                    <div className="float-end pt-4">
                      <Button
                        className="text-medium form-save-button"
                        type="primary"
                        htmlType="submit"
                        disabled={buttonLoader}
                        onClick={handleSubmit}
                      >
                        {buttonLoader ? (
                          <Spin
                            indicator={<LoadingOutlined spin />}
                            size="small"
                            className="w-10"
                          />
                        ) : (
                          "Import"
                        )}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </Loadercomponent>
              </div>
            </Bodycomponent>
          </Formcomponent>
        </Loadercomponent>
      </ScrollWrapper>
    </Header>
  );
};

export default ImportForm;
